import React, { Component } from "react";
import "./style.css";
class PayErrorTip extends Component {
  render() {
    return (
      <div className="pay_error_tip">
        <div className="pay_error_tip_text">
          请在微信中打开
          <div
            onClick={() => this.props.handleClosePayErrorTip()}
            className="pay_error_btn"
          >
            确 定
          </div>
        </div>
      </div>
    );
  }
}

export default PayErrorTip;



// WEBPACK FOOTER //
// ./src/containers/Pay/components/PayErrorTip/index.js